import { LegacyPlayerBaseInfoContent } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { PlayerType } from '../../ui/player/container';

const map: Record<
    NonNullable<Exclude<LegacyPlayerBaseInfoContent, null>['__typename']>,
    PlayerType | null
> = {
    Clip: 'clip',
    Episode: 'episode',
    Film: 'film',
    OttTrailer: 'trailer',
    TvChannel: 'channel',
    Video: 'film',
    SportBroadcast: 'sport',
};

export const getPlayerType: (
    contentType: Exclude<LegacyPlayerBaseInfoContent, null>['__typename'] | undefined
) => PlayerType | null = (contentType) => (contentType ? map[contentType] : null);
